// Starting up Alpine
import Alpine from "alpinejs"
import focus from '@alpinejs/focus'
import ui from '@alpinejs/ui'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'

window.Alpine = Alpine
Alpine.plugin(focus)
Alpine.plugin(ui)
Alpine.plugin(intersect)
Alpine.plugin(collapse)

Alpine.data("scrollInteraction", () => ({
    // --- State Variables ---
    activeSectionId: 'section1', // ID of the currently intersecting section
    activeImageUrl: '',          // URL of the image to display in the sticky container
    imageOpacity: 0,             // Opacity of the sticky image (0 for faded out, 1 for faded in)

    // --- Initialization ---
    init() {
        const firstSection = document.getElementById('section1'); // Or use a more specific selector if needed
        try {
             if (firstSection && firstSection.dataset.imageSrc) {
                this.activeImageUrl = firstSection.dataset.imageSrc;
                // The @load event on the image will set opacity to 1 after loading
             } 
        } catch (e) {
            this.activeImageUrl = 'https://placehold.co/640x480/cccccc/ffffff?text=Error+Init';
            // this.imageOpacity = 1; // Make error visible immediately if needed
        }
    },

    // --- Methods ---
    /**
     * Sets the active section and triggers the image update.
     * Called by x-intersect when a content block enters the viewport.
     * @param {string} sectionId - The ID of the intersecting section.
     * @param {HTMLElement} element - The intersecting DOM element.
     */
    setActiveSection(sectionId, element) {
        const newImageUrl = element.dataset.imageSrc;

        // Only update if the image URL is different from the current one
        if (this.activeImageUrl !== newImageUrl) {
            this.imageOpacity = 0; // Start fade-out transition
            // Use $nextTick to wait for the opacity change to apply
            // before updating the image source, preventing flicker.
            this.$nextTick(() => {
                this.activeSectionId = sectionId;    // Update the tracked section ID
                this.activeImageUrl = newImageUrl; // Update the image URL (triggers loading)
                // DEBUG: Confirm state variable was updated *inside* nextTick
            });
        } 
    },

    /**
     * Called by the @load event on the sticky image tag.
     * Sets the image opacity to 1, triggering the fade-in effect.
     */
    onImageLoad() {
        this.imageOpacity = 1; // Start fade-in transition
    }
}));



// Global scroll handler
Alpine.data("scrollHandler", () => ({
    scrollToNextSection() {
        const hero = event.target.closest(".HeroTwoBlock");
        const nextSection = hero?.nextElementSibling; // Get the next sibling section
        const header = document.querySelector("header"); // Optional: Sticky header
        const headerHeight = header ? header.offsetHeight : 0; // Get header height if it exists
    
        if (nextSection) {
            const offset = nextSection.offsetTop - headerHeight; // Calculate scroll offset
            window.scrollTo({ top: offset, behavior: "smooth" }); // Smooth scroll
        }
        
    },
}));


Alpine.start();